import { render, staticRenderFns } from "./PuchoutInfoBanner.vue?vue&type=template&id=6b8cf07c&scoped=true&"
import script from "./PuchoutInfoBanner.vue?vue&type=script&lang=js&"
export * from "./PuchoutInfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./PuchoutInfoBanner.vue?vue&type=style&index=0&id=6b8cf07c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8cf07c",
  null
  
)

export default component.exports